import React from 'react';
import { type BrevoSyncRitmoPunto } from '../../api/brevoSyncApi';

interface RitmoSparklineProps {
  puntos: BrevoSyncRitmoPunto[];
  width?: number;
  height?: number;
  color?: string;
}

const RitmoSparkline: React.FC<RitmoSparklineProps> = ({ puntos, width = 120, height = 36, color = '#1890ff' }) => {
  if (puntos.length < 2) return null;

  const values = puntos.map(p => p.contactos);
  const max = Math.max(...values, 1);
  const padding = 2;
  const w = width - padding * 2;
  const h = height - padding * 2;

  const points = values.map((v, i) => {
    const x = padding + (i / (values.length - 1)) * w;
    const y = padding + h - (v / max) * h;
    return `${x.toFixed(1)},${y.toFixed(1)}`;
  }).join(' ');

  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} style={{ display: 'block' }}>
      <polyline
        points={points}
        fill="none"
        stroke={color}
        strokeWidth="1.5"
        strokeLinejoin="round"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default RitmoSparkline;
